export const companyUsersTagName = 'tm-company-users';
export const companyUserStatusConfirmationTagName = 'user-status-confirmation';
export const companyUserListTagName = 'tm-company-user-list';
